import {createClient} from "@sanity/client";
// const sanityClient = require('@sanity/client')

export const client = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID, // find this at manage.sanity.io or in your sanity.json
  dataset: "production", // this is from those question during 'sanity init'
  apiVersion: '2021-10-21',
  useCdn: true,
  token: process.env.REACT_APP_SANITY_TOKEN
});